import { Input } from '@quero-delivery/quero-components-web';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';

import type { IWeekDay, TWeekDay } from '@/Interfaces/Data';

import styles from './styles.module.scss';

interface Props {
  weekDay: IWeekDay;
  weekDayKey: TWeekDay;
}

function Schedule({ weekDay, weekDayKey }: Props) {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: weekDayKey,
  });

  const hours = watch(`${weekDayKey}`);

  return (
    <div className={styles.containerDia}>
      <div className={styles.header}>
        <h3>{weekDay.shortName}</h3>
        <button
          className={styles.actionButton}
          onClick={() => {
            append({ horaInicial: '00:00', horaFinal: '00:00' });
          }}
          type="button"
        >
          <FontAwesomeIcon icon={faPlus} size="xs" />
        </button>
      </div>
      <div className={styles.containerHorarios}>
        {fields.map((field, index) => {
          const errorsWeekDay = errors[weekDayKey]
            ? // TODO fix ts
              // @ts-ignore
              errors[weekDayKey][index]
            : null;

          const startHour = hours[index] ? hours[index].horaInicial : '00:00';
          const endHour = hours[index] ? hours[index].horaFinal : '00:00';

          return (
            <div key={field.id} className={styles.horario}>
              <div className={styles.timeHeader}>
                <b>horário {index + 1}</b>
                <button
                  className={styles.actionButton}
                  onClick={() => {
                    remove(index);
                  }}
                  type="button"
                >
                  <FontAwesomeIcon icon={faMinus} size="xs" />
                </button>
              </div>

              <Controller
                control={control}
                defaultValue={startHour}
                name={`${weekDayKey}.${index}.horaInicial`}
                render={({ field }) => (
                  <Input
                    {...field}
                    label="início"
                    type="time"
                    placeholder="início"
                  />
                )}
              />

              <Controller
                control={control}
                name={`${weekDayKey}.${index}.horaFinal`}
                defaultValue={endHour}
                rules={{
                  validate: (value: string) => {
                    const [endHours, endMinutes] = value.split(':');
                    const [startHours, startMinutes] = startHour.split(':');

                    if (endHours < startHours) {
                      return 'Intervalo inválido';
                    }

                    if (startHours === endHours && endMinutes <= startMinutes) {
                      return 'Intervalo inválido';
                    }

                    return true;
                  },
                }}
                render={({ field }) => (
                  <Input
                    {...field}
                    label="fim"
                    type="time"
                    placeholder="fim"
                    errorMessage={
                      errorsWeekDay && errorsWeekDay.horaFinal
                        ? errorsWeekDay.horaFinal.message
                        : null
                    }
                  />
                )}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Schedule;
